import api from "./api-manager";

const { REACT_APP_API_A39 } = process.env;

export default {
  async GetContactInfo(token, adsId) {
    return api.post(
      `/v1/contact/info`,
      { adsId },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
};
